// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2672) return "static/chunks/2672-7da66443499aba46.js";
	if (chunkId === 7798) return "static/chunks/7798-df9a5b47ac51613a.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2328":"077b708962f60920","2429":"95eefb32bba3bd36","4112":"d6e477c491c84729","5059":"83cde900e8e5d733","6914":"24d4cdf3dedf02b3","8709":"54fe57cf5da94c50"}[chunkId] + ".js";
};